// import React from 'react';
import { createRoot } from 'react-dom/client';
import './css/index.css';
//import '@asu-design-system/bootstrap4-theme/dist/css/bootstrap-asu.min.css';
// import CatalogSearch from './CatalogSearch';
// import ClassSearch from './ClassSearch';
// import serviceauth from './auth/serviceauth'
import * as serviceWorker from './serviceWorker';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(App.App());

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
